import React, { useEffect, useState, useRef } from 'react'
import {
	Typography,
	Paper,
	ExpansionPanel,
	ExpansionPanelSummary,
	ExpansionPanelDetails,
	ButtonGroup,
	Button,
	Select,
	MenuItem,
	Grid,
	FormControl,
	InputLabel,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { Chart } from 'react-google-charts'
import DataFilters from '../DataFilters'
import axios from 'axios'
import OrganisationalCompensation from '../OrganisationalCompensation'
import { hasPermissions } from '../../../../helpers/AccessControl/AccessControl'

// styles
import { useStyles } from '../styles'

const COLUMN_HEIGHT_RATIO = 800

export default function CashCompensation(props) {
	const classes = useStyles();
	const [reportData, setReportData] = useState(null)
	const [totalHeadCount, setTotalHeadCount] = useState(0)
	const [graphHeight, setGraphHeight] = useState(0)
	const [expanded, setExpanded] = useState([])
	const [available, setAvailable] = useState('P50')
	var selectChoice = useRef(false)
	var bothPercentile = useRef(false)

	const handlePanelChange = (panelName) => {
		let expandedArray = [...expanded]
		if (expandedArray.includes(panelName)) {
			expandedArray.splice(expandedArray.indexOf(panelName), 1);
		} else {
			expandedArray.push(panelName)
		}
		setExpanded(expandedArray)
		localStorage.setItem('compensation_open_reports', JSON.stringify(expandedArray))
	}

	useEffect(() => {
		if (localStorage.getItem('compensation_open_reports') !== null) {
			let localWorkForceOpenReports = JSON.parse(localStorage.getItem('compensation_open_reports'))
			setExpanded(localWorkForceOpenReports)
		}
	}, [])

	useEffect(() => {
		const fetchReportData = async () => {
			setGraphHeight(0)
			let params = {
				'country': props.reportFilters['DepartmentalCompensation']['dataFilters']['country'],
				'department': props.reportFilters['DepartmentalCompensation']['dataFilters']['department'],
			}
			try {
				const result = await axios.post(`/api/report/cashcompensation`, params)
				const reportData = result.data.data
				let P50 = false, P75 = false
				let localAvailable = 'P50'
				if(!selectChoice.current) {
					if(localStorage.getItem('Percentile') === null) {
						reportData.forEach((rd) => {
							if(rd.avg_comp_salary_p50 !== 0) {
								console.log(rd)
								P50 = true
							}
							if(rd.avg_comp_salary_p75 !== 0) {
								P75 = true
							}
						})
						if(P50 === true) {
							setAvailable('P50')
							localAvailable = 'P50'
						}
						else {
							setAvailable('P75')
							localAvailable = 'P75'
						}
						if(P50 && P75) {
							bothPercentile.current = true
						}
					}
					else {
						const persistedPercentile = JSON.parse(localStorage.getItem('Percentile'))
						setAvailable(persistedPercentile.available)
						localAvailable = persistedPercentile.available
						bothPercentile.current = persistedPercentile.both
					}
				}
				else {
					localAvailable = available
					const persistedPercentile = {
						available: available,
						both: bothPercentile,
					}
					localStorage.setItem('Percentile', JSON.stringify(persistedPercentile))
				}
				const processedData = [['Department', localAvailable, {role: 'tooltip'}, {role: 'annotation'}]]
				let totalCount = 0
				reportData.forEach((rd) => {
					var percentile = (localAvailable === 'P50' ? rd.avg_comp_salary_p50 - 1 :  rd.avg_comp_salary_p75 - 1 )
					processedData.push(
						[rd.department + ' (' + rd.total + ')', 
						percentile === 0 ? 0.001 : (percentile) , 
						`${rd.department + ' (' + rd.total + ')'}\n${localAvailable}: ${(percentile * 100).toFixed(1)}%`, 
						percentile === 0 ? `${localAvailable}: 0.0%` : null 
						])
					totalCount += rd.total
					setGraphHeight(graphHeight + COLUMN_HEIGHT_RATIO)
					// }
				})
				setTotalHeadCount(totalCount)
				setReportData(processedData)

			} catch (e) {
				setReportData([])
			}
		}
		fetchReportData()
	}, [available, props.departmentReportVersion])

	const onApply = () => {
		props.onApply('DepartmentalCompensation')
	}

	return (
		<>
			{hasPermissions(['departmental_compensation']) && <ExpansionPanel onChange={() => handlePanelChange('departmental_compensation')} expanded={expanded.includes('departmental_compensation')}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography className={classes.heading}>
						Departmental Compensation
					</Typography>

				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.organizationExpansionPanel}>
					<Paper className={classes.root}>
						<Typography className={classes.typo} variant='h5' size='sm'>
							Filters
						</Typography>
						<DataFilters
							fetchedFilterData={props.fetchedFilterData}
							filtersData={props.filtersData['DepartmentalCompensation']}
							reportDataChanged={props.reportDataChanged}
							onDataFilterSelect={props.onDataFilterSelect}
							componentName={'DepartmentalCompensation'}
							reportFilters={props.reportFilters['DepartmentalCompensation']}
							onApply={onApply}
							enabledFilters={['country', 'department']}
							resetFilter={props.resetFilter}
							reportFiltersType={props.reportFiltersType['DepartmentalCompensation']}
						/>
						{
							bothPercentile.current? 
							<Grid container xs={11} direction={'row-reverse'} justify={'flex-start'} alignItems={"center"}>
								<FormControl className={classes.formMinWidth}>
									<InputLabel >Percentile</InputLabel>
									<Select
									autoWidth={true}
									value={available}
									onChange={e => {
										selectChoice.current = true
										setAvailable(e.target.value)
									}}
									>
										<MenuItem value={'P50'}>P50</MenuItem>
										<MenuItem value={'P75'}>P75</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							: null
						}
						{
							reportData ?
								reportData.length !== 1 ?
									<Chart
										chartType='BarChart'
										data={reportData}
										options={{
											title: 'Salary ratio Comparision By Departments' + ' (N = ' + totalHeadCount + ')',
											chartArea: { 'width': '70%', 'height': '80%' },
											isStacked: true,
											hAxis: {
												title: 'Salary Ratio',
												minValue: 0,
												format: '#%'
											},
											vAxis: {
												title: 'Departments',
											},
											tooltip: {
												isHtml: true,
											},
										}}
										width='100%'
										height={graphHeight.toString() + 'px'}
										legendToggle
									/>
									:
									<Typography>No Data</Typography>
								:
								<Typography>Loading...</Typography>
						}
					</Paper>
				</ExpansionPanelDetails>
			</ExpansionPanel>}
			{hasPermissions(['organizational_compensation']) && <ExpansionPanel onChange={() => handlePanelChange('organizational_compensation')} expanded={expanded.includes('organizational_compensation')}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography className={classes.heading}>
						Organizational Compensation
					</Typography>

				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.organizationExpansionPanel}>
					<Paper className={classes.root}>
					{props.reportDataChanged['OrganisationCompensation'] && 
					<span className={classes.notificationSpan}>Employees data has been updated please click the Apply button or Reset Button</span>}
						<OrganisationalCompensation
							fetchedFilterData={props.fetchedFilterData}
							filtersData={props.filtersData['OrganisationCompensation']}
							reportDataChanged={props.reportDataChanged}
							masterData={props.masterData}
							onDataFilterSelect={props.onDataFilterSelect}
							componentName={'OrganisationCompensation'}
							reportFilters={props.reportFilters['OrganisationCompensation']}
							reportData={props.reportData['OrganisationCompensation']}
							onApply={props.onApply}
							availableColumns={props.availableColumns}
							resetFilter={props.resetFilter}
							reportFiltersType={props.reportFiltersType['OrganisationCompensation']}
						/>
					</Paper>
				</ExpansionPanelDetails>
			</ExpansionPanel>}
		</>
	)
}
